import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!-- @glint-nocheck: this template is not typesafe yet --}}\n{{component @composer.config.customStylesConfig.colorPickerComponent value=this.selectedColor setColor=this.onChangeColor}}", {
  moduleName: "@intercom/composer-ember/components/utils/color-picker.hbs"
});